import { defineModule, defineRoute } from "../../shared/define-module"
import type { GetStatusConfigsResponse } from "./types"

/**
 * Status module for system status and configuration
 */
export const statusModule = defineModule({
  name: "status",
  prefix: "/status",
  routes: {
    // Get system status configurations
    getConfigs: defineRoute<never, GetStatusConfigsResponse>("GET", "/configs"),
  },
})

// Export the API type
export type StatusAPI = typeof statusModule.api

// Re-export types for external consumption
export type * from "./types"
